import React from 'react';
import './Banner.css';

const SLOGAN_WORDS = ['One', 'Ecosystem.', 'Infinite', 'Potential!'];

const Banner = () => (
  <div className="cb-root">
    <div className="cb-hero">

      {/* LEFT — student image, slogan sits below the image */}
      <div className="cb-visual">
        <div className="cb-rings-wrapper">
          <span className="cb-ring cb-ring--outer" />
          <span className="cb-ring cb-ring--inner" />
          <span className="cb-ring cb-ring--solid" />
          <div className="cb-img-wrap">
            <img src="/heroes/student_group.webp" alt="Students" className="cb-img" />
          </div>
        </div>
        <p className="cb-slogan" aria-label="One Ecosystem. Infinite Potential!">
          {SLOGAN_WORDS.map((word, i) => (
            <span key={word} className="cb-slogan-word" style={{ '--i': i }}>
              {word}
            </span>
          ))}
        </p>
      </div>

      {/* RIGHT — heading + tagline */}
      <div className="cb-text">
        <h1 className="cb-heading">From Campus to Career</h1>
        <p className="cb-tagline">building futures that matter.</p>
      </div>

    </div>
  </div>
);

export default Banner;
